/* Phần dùng chung của khu Community (Friends, Contributions, Discover, Onboarding). */
import type { ReactNode } from "react"
import { Card } from "@/components/ui/card"
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible"
import { Icon } from "@/components/icon"
import { BadgeMedallion } from "@/components/simba"

/** Khối mở/đóng nhẹ nhàng thay cho <details> cũ. */
export function Disclosure({ title, meta, children, defaultOpen = false }: { title: ReactNode; meta?: ReactNode; children: ReactNode; defaultOpen?: boolean }) {
  return (
    <Card size="sm" className="py-0">
      <Collapsible defaultOpen={defaultOpen} className="group/disc">
        <CollapsibleTrigger className="flex w-full items-center gap-3 px-4 py-4 text-left font-heading text-base font-semibold text-ink outline-none focus-visible:ring-3 focus-visible:ring-ring/50">
          <span className="min-w-0 flex-1">{title}</span>
          {meta}
          <Icon name="chevron-down" className="size-4 transition-transform group-data-[open]/disc:rotate-180" />
        </CollapsibleTrigger>
        <CollapsibleContent className="px-4 pb-4">{children}</CollapsibleContent>
      </Collapsible>
    </Card>
  )
}

/** Lưới huy hiệu nhỏ; co về 2 cột trên điện thoại. */
export function BadgeGrid({ badges, empty }: { badges: any[]; empty: string }) {
  if (!badges.length) return <p className="rounded-2xl bg-soft px-4 py-6 text-center text-sm text-muted-foreground">{empty}</p>
  return (
    <ul className="grid grid-cols-2 gap-3 sm:grid-cols-3">
      {badges.map((b) => (
        <li key={b.id} className="flex flex-col items-center gap-1 rounded-2xl bg-sand/60 p-3 text-center" title={b.description || b.reason || undefined}>
          <BadgeMedallion name={b.name} description={b.description} earned className="w-16" />
          <span className="text-sm font-semibold text-ink">{b.name}</span>
        </li>
      ))}
    </ul>
  )
}

export const contributionCategories: Record<string, string> = {
  feature_request: "Bổ sung tính năng",
  feature_adjustment: "Điều chỉnh tính năng",
  bug: "Báo lỗi",
  feedback: "Phản hồi",
  idea: "Ý tưởng mới",
  other: "Nội dung khác",
}

export const pct = (v: number) => `${Math.round((v || 0) * 100)}%`
